function mapGetListFeedItemsData(responseData) {
    return responseData.map((data) => ({
        ...data,
    }));
}

export { mapGetListFeedItemsData };
